import { render, staticRenderFns } from "./MenuRecord.vue?vue&type=template&id=5db8cd9c&"
import script from "./MenuRecord.vue?vue&type=script&lang=js&"
export * from "./MenuRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports